module.exports = __webpack_public_path__ + "img/about_yourself.66eaf0f7.svg";